module.exports = [{"browser":{"name":"Firefox","version":44},"platform":{"type":"desktop"}}]